export const SEARCH_RECIPES = {
  container: "underline lg:h-[110px] h-[158px] flex items-center",
  button:
    "bg-white rounded-[25px] text-darkBlue h-50 text-18 font-Regular px-30 lg:ml-20  mt-20 lg:mt-0 w-full lg:w-auto",
  serachWrpr:
    "serachWrpr lg:w-[1170px] lg:mx-auto mx-10 flex flex-wrap w-full justify-center",
  searchboxStyles: {
    formContainer:
      "formContainer bg-white rounded-[25px] lg:w-400 w-full flex flex-wrap h-50",
    form: "form  flex items-center justify-center w-4/5",
    image: "image w-[25px] ml-10 text-[25px] mt-5",
    input:
      "input bg-transparent w-full ml-10 flex h-full outline-none placeholder-placeholderColor",
    searchPlaceHolder: "placeholder-darkBlue",
  },
}

export const SEARCH_RECIPES_JOB_LISTING = {
  container: "flex items-center",
  button:
    "bg-white rounded-[25px] text-darkBlue h-50 text-18 font-Regular px-30 lg:ml-20  mt-20 lg:mt-0 w-full lg:w-auto",
  serachWrpr:
    "serachWrpr lg:w-[1170px] lg:mx-auto mx-10 flex flex-wrap w-full justify-center",
  searchboxStyles: {
    formContainer:
      "formContainer bg-white rounded-[25px] w-full flex flex-wrap pb-[25px]",
    form: "form  flex items-center justify-center w-full",
    image:
      "image flex justify-center items-center bg-[#4f2170] text-white w-[30px] md:w-[50px] h-[30px] md:h-[50px] cursor-pointer",
    input:
      "input font-Light bg-none border-b-[1px] border-solid border-[#666666] pl-[15px] text-16 lg:text-[48px] text-black inline-block w-full md:w-[60%] font-[300]",
    searchPlaceHolder: "placeholder-darkBlue",
    validationError:
      "validationError text-16 max-w-[445px] md:max-w-[68%] xl:max-w-[760px] w-full mx-auto text-errorRed",
  },
}
